<template>
	<div class="flex relative w-full h-screen overflow-hidden items-center justify-center" :class="heroBgColor">
		<img :src="heroPath" alt="Logo" class="absolute object-cover" :class="heroClassData" />

		<div class="absolute rounded-xl bg-neutral my-auto w-[370px] h-[261px] text-center p-12">
			<img src="@/assets/images/icon/checkmark-rounded-green-bg.svg" class="mx-auto" alt="Success" title="Success">
			<p class="text-[32px] font-extrabold my-8">Success</p>
			<p class="font-medium text-label">Logging you in...</p>
		</div>
	</div>
</template>

<script setup lang="js">

import { onMounted, ref } from 'vue'
import router from '@/router/router.js'
import { Tenants } from '@/models/tenants/Tenants.js'

const heroPath = ref('')
const heroBgColor = ref('')
const heroClassData = ref('')

onMounted(() =>
{
	const tenant = Tenants.getTenant()
	heroPath.value = new URL(`../../assets/images/theme/${tenant.hero.image}`, import.meta.url).href
	heroBgColor.value = tenant.hero.background
	heroClassData.value = tenant.hero.classData

	setTimeout(() =>
	{
		router.push({ name: 'dashboard' })
	}, 2000)
})

</script>
